import { useState, useEffect } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import EditNoteIcon from '@mui/icons-material/EditNote';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { Box, Button } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import CollapsibleTable from '../../components/CollapsibleTable';
import ModalIncarcareSemnata from '../../components/ModalIncarcareSemnata';
import ModalModificari from '../../components/ModalModificari';
import { descarcaCerere, ultimaCerere } from '../../utils/descarcaCerere';
import MesajInchidere from '../../components/MesajInchidere';
import { usePlatforma } from '../../platforma';

// starea celei mai recente cereri a unui student
const stareCerere = (cerere) => {
    if (!cerere) return 'Fără cerere';
    if (cerere.mesaj_modificari) return 'Modificări solicitate';
    return cerere.e_semnat === 1 ? 'Semnată' : 'Așteaptă semnătura';
};

function AcceptedRequests() {
    const SERVER = process.env.REACT_APP_SERVER;
    const [refresh, setRefresh] = useState(false);
    const [acceptedStudents, setAcceptedStudents] = useState([]);
    const [uploadModal, setUploadModal] = useState(null);
    const [modificariModal, setModificariModal] = useState(null);
    const [prof, setProf] = useState();

    useEffect(() => {
        preluareProfesor();
        preluareStudenti();
    }, [refresh]);

    const preluareProfesor = async () => {
        const professorResponse = await fetch(`${SERVER}user`, {
            method: 'GET',
            headers: {
                Authorization: localStorage.getItem('token'),
                'Content-Type': 'application/json',
            },
        });
        const professorData = await professorResponse.json();
        setProf(professorData.instanta);
    }

    const preluareStudenti = async () => {
        try {
            const studResp = await fetch(`${SERVER}colaborari`, {
                method: 'GET',
                headers: {
                    Authorization: localStorage.getItem('token'),
                    'Content-Type': 'application/json',
                },
            });
            const studData = await studResp.json();
            const accepted = [];
            for (let student of studData.acceptati) {
                const { titlu } = student.Solicitaris[0];
                const specializare = student.Specializari.nume;
                const cereri = student.Cereris.length > 0 ? student.Cereris.map(c => c.titlu).join("; ") : 'Nu are cereri.';
                const cerere = ultimaCerere(student);
                accepted.push({ ...student, titlu, specializare, cereri, cerere, stare: stareCerere(cerere) });
            }
            setAcceptedStudents(accepted);
        } catch (e) {
            console.error(e)
        }
    }

    const dupaActiune = () => {
        setUploadModal(null);
        setModificariModal(null);
        setRefresh(r => !r);
    };

    // dupa inchiderea platformei cererile pot fi doar descarcate
    const { inchisa } = usePlatforma();

    const renderButtons = (row) => {
        if (inchisa) {
            return <Button disabled={!row.cerere} startIcon={<DownloadIcon />} onClick={() => { descarcaCerere(row); }}>Descarcă</Button>;
        }
        const asteaptaSemnatura = row.cerere && row.cerere.e_semnat === 0 && !row.cerere.mesaj_modificari;
        return (
            <>
                <Button disabled={!row.cerere} startIcon={<DownloadIcon />} onClick={() => { descarcaCerere(row); }}>Descarcă</Button>
                <Button disabled={!asteaptaSemnatura} startIcon={<UploadFileIcon />} onClick={() => {
                    document.documentElement.scrollTop = 0;
                    setUploadModal(row);
                }} >Încarcă cererea semnată</Button>
                <Button color="warning" disabled={!row.cerere || !!row.cerere.mesaj_modificari} startIcon={<EditNoteIcon />} onClick={() => {
                    document.documentElement.scrollTop = 0;
                    setModificariModal(row);
                }}>Solicită modificări</Button>
            </>
        );
    };

    return (
        <Box sx={{ margin: "100px 10px" }}>
            <MesajInchidere isProfessor />
            {prof && prof.grad_didactic ? (
                prof.numar_studenti_maxim > 0 ? (
                    <>
                        {acceptedStudents.length > 0 ? <CollapsibleTable rows={acceptedStudents} renderButtons={renderButtons} columns={[
                            { label: 'Nr.', id: 'nr' },
                            { label: 'Email', id: 'email' },
                            { label: 'Specializare', id: 'specializare' },
                            { label: 'An', id: 'an' },
                            { label: 'Grupă', id: 'grupa' },
                            { label: 'Titlu orientativ', id: 'titlu' },
                            { label: 'Titlu cereri', id: 'cereri' },
                            { label: 'Stare cerere', id: 'stare' },
                            { label: '', id: 'buttons' }
                        ]} /> : <Box sx={{ backgroundColor: "white", padding: "20px", margin: "100px 20px" }}>Nu aveți cereri.</Box>}
                        {uploadModal && (
                            <ModalIncarcareSemnata student={uploadModal} cerere={uploadModal.cerere} profesor={prof}
                                onInchide={() => setUploadModal(null)} onSucces={dupaActiune} />
                        )}
                        {modificariModal && (
                            <ModalModificari student={modificariModal} cerere={modificariModal.cerere}
                                onInchide={() => setModificariModal(null)} onSucces={dupaActiune} />
                        )}
                    </>
                ) : (
                    <Box sx={{ backgroundColor: "white", padding: "20px", margin: "20px" }}>
                        Vă rugăm așteptați ca directorul de departament să vă seteze limita maximă admisă de studenți.
                    </Box>
                )
            ) : (
                <Box sx={{ backgroundColor: "white", padding: "20px", margin: "20px" }}>
                    Completați datele personale în pagina de profil, din meniul lateral.
                </Box>
            )}
        </Box>
    );
}

export default AcceptedRequests;
